import deviceName from '../constants';

export default (authSystem, deviceType) => {
    const device = deviceName[deviceType] || 'device';
    if (authSystem === 'adobepass') {
        return `Your ${device} is Activated`;
    }
    return `Your ${device} has been connected to your ESPN account`;
};



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/util/getSuccessText.js